/**
 * The editor's userActivityElement has a keydown listener that emits
 * modify_dictation for field-navigation shortcuts. That listener only sees
 * keystrokes in its own window with focus inside itself.
 *
 * This function is consulted on the cross-tab shortcut path and returns
 * true whenever that keydown listener will NOT cover the keystroke:
 * the shortcut came from a different window, or focus was elsewhere when
 * it was pressed. In those cases, the cross-tab path is solely responsible
 * for emitting modify.
 */
export const shouldSendModifyFromCrossTabShortcut = ({
  source,
  activeElement,
  userActivityElement,
}: {
  source: 'local' | 'remote';
  activeElement: Element | null;
  userActivityElement: HTMLElement | null;
}) => {
  if (source === 'remote') return true;

  // Local shortcuts already trigger modify_dictation from keydown when focus is inside
  // the recorder activity element. Only send here when that keydown path won't run.
  if (activeElement == null || userActivityElement == null) return true;
  return !userActivityElement.contains(activeElement);
};
